import Vue from "vue";
import Router from "vue-router";
import Home from "./components/Home.vue";
import Work from "./components/Work.vue";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
          {
            path: "/home",
            name: "home",
            component: Home,
          },
          {
            path: "/work",
            name: "work",
            component: Work,
          },
          {
            path: "*",
            redirect: '/home'
          },
    ],
    scrollBehavior(to, from, savedPosition) {
      return { x: 0, y: 0 };
    }});

export default router;
